import React, { useEffect, useState } from 'react';

const tickerMetrics = [
  { label: 'Revenue', value: '$1.24M', change: '+12.4%', up: true },
  { label: 'Orders', value: '2,847', change: '+8.1%', up: true },
  { label: 'Avg Ticket', value: '$42.30', change: '+2.3%', up: true },
  { label: 'Labor Cost', value: '28.1%', change: '-3.1%', up: false },
  { label: 'Inventory Turns', value: '8.2x', change: '+1.4%', up: true },
  { label: 'Retention', value: '94.2%', change: '+0.8%', up: true },
  { label: 'Margin', value: '38.7%', change: '+4.2%', up: true },
  { label: 'Fulfillment', value: '99.1%', change: '+0.3%', up: true },
  { label: 'Active Users', value: '1,204', change: '+15.7%', up: true },
  { label: 'CSAT Score', value: '4.8', change: '+0.2', up: true },
];

const Hero = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-screen flex items-end bg-white overflow-hidden pb-20 md:pb-32">
      {/* Content - left aligned, not centered */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full pt-40">
        <div className="max-w-3xl">
          {/* Eyebrow with animated line */}
          <div className={`flex items-center gap-4 mb-8 transition-all duration-1000 delay-300 ${
            loaded ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
          }`}>
            <div className="h-px w-12 bg-zinc-900" />
            <span className="text-xs uppercase tracking-[0.25em] text-zinc-500">
              Operational Intelligence
            </span>
          </div>

          {/* Headline - each line enters separately */}
          <h1 className="mb-8">
            <span className={`block text-[clamp(2.5rem,6vw,5rem)] font-light text-zinc-900 leading-[1.05] transition-all duration-1000 delay-500 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
            }`}>
              See your entire
            </span>
            <span className={`block text-[clamp(2.5rem,6vw,5rem)] font-light text-zinc-900 leading-[1.05] transition-all duration-1000 delay-700 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
            }`}>
              operation.
            </span>
            <span className={`block text-[clamp(2.5rem,6vw,5rem)] font-extralight text-zinc-300 leading-[1.05] transition-all duration-1000 delay-[900ms] ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
            }`}>
              In one place.
            </span>
          </h1>

          {/* Body */}
          <p className={`text-lg md:text-xl text-zinc-500 font-light leading-relaxed max-w-lg mb-12 transition-all duration-1000 delay-[1100ms] ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}>
            From a five-person restaurant to a five-thousand-person enterprise.
            One platform. Every answer.
          </p>

          {/* CTA - just text with an arrow, not a big button */}
          <div className={`flex flex-col sm:flex-row items-start gap-6 transition-all duration-1000 delay-[1300ms] ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}>
            <a
              href="mailto:contact@arbcor.com"
              className="group flex items-center gap-3 text-sm tracking-wider text-zinc-900 uppercase"
            >
              Request early access
              <span className="inline-block w-8 h-px bg-zinc-900 group-hover:w-12 transition-all duration-500" />
            </a>
            <button
              onClick={() => document.getElementById('platform')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-sm tracking-wider text-zinc-400 uppercase hover:text-zinc-600 transition-colors duration-500"
            >
              Explore
            </button>
          </div>
        </div>
      </div>

      {/* Bottom right - section indicator */}
      <div className={`absolute bottom-8 right-8 hidden md:flex flex-col items-end gap-1 transition-all duration-1000 delay-[1500ms] ${
        loaded ? 'opacity-100' : 'opacity-0'
      }`}>
        <span className="text-[11px] text-zinc-300 tracking-wider">SCROLL</span>
        <div className="w-px h-12 bg-zinc-200 relative overflow-hidden">
          <div className="w-full h-4 bg-zinc-400 animate-[slideDown_2s_ease-in-out_infinite]" />
        </div>
      </div>
      {/* Metric ticker — bottom edge */}
      <div className={`absolute bottom-0 left-0 right-0 overflow-hidden border-t border-zinc-100 transition-all duration-1000 delay-[1700ms] ${
        loaded ? 'opacity-100' : 'opacity-0'
      }`}>
        <div className="flex animate-[tickerScroll_30s_linear_infinite] w-max py-3">
          {[...tickerMetrics, ...tickerMetrics].map((m, i) => (
            <div key={i} className="flex items-center gap-3 px-6 border-r border-zinc-100">
              <span className="text-[10px] uppercase tracking-wider text-zinc-400">{m.label}</span>
              <span className="text-sm font-medium text-zinc-900 tabular-nums">{m.value}</span>
              <span className={`text-[10px] tabular-nums ${m.up ? 'text-zinc-500' : 'text-zinc-400'}`}>
                {m.up ? '▲' : '▼'} {m.change}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
